
import { Scope } from '@ms/utilities-disposables/lib/Scope';

/**
 * Executes an asynchronous tasks with access to a scope, which will clean up
 * any attached disposables when the task completes, success or failure.
 * @public
 */
export async function withScope<TResult>(
  getResult: (scope: Scope) => Promise<TResult>
): Promise<TResult> {
  const scope = new Scope();

  try {
    return await getResult(scope);
  } finally {
    scope.dispose();
  }
}
